import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import Select from "react-select";
import { Link, useHistory } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  CardHeader,
  Label,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Pagination,
  PaginationItem,
  Collapse,
  PaginationLink,
  Input,
} from "reactstrap";
import TicketListRow from "./TicketList";
import Dropzone from "react-dropzone";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InputMask from "react-input-mask";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import classnames from "classnames";
import jwt_decode from "jwt-decode";
import axios from "../api/axios";

const TicketList = () => {
  const decode = jwt_decode(window.localStorage.getItem("accessToken"));
  const userRole = JSON.parse(window.localStorage.getItem("authUser"))?.role || decode.role;

  const CUSTOMER_SEARCH_URL = "/ticket/filter_tickets_customer";
  const MANAGER_SEARCH_URL = "/ticket/filter_tickets_manager";
  const COMPANY_SEARCH_URL = "/ticket/filter_tickets_company";
  const EXCEL_DOWNLOAD_URL = "/ticket/download_excel";

  const [col5, setcol5] = useState(false);
  const t_col5 = () => setcol5(!col5);

  const history = useHistory();
  const [modal_large, setmodal_large] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");

  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filtername, setFiltername] = useState("");
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [notesCount, setNotesCount] = useState({});
  const [totalTickets, setTotalTickets] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [propertyManagerList, setPropertyManagerList] = useState([]);
  const [filterPropertyManager, setFilterPropertyManager] = useState("");
  const [filterVendor, setFilterVendor] = useState("");
  const [filterTechnicalStaff, setFilterTechnicalStaff] = useState("");
  const [selectPropertyName, setSelectPropertyName] = useState(null);
  const [selectVendorName, setSelectVendorName] = useState(null);
  const [selectTechnicalStaffName, setSelectTechnicalStaffName] = useState(null);
  const [pageLimit] = useState(10);
  const [requestTypes, setRequestTypes] = useState([]);
  const [requestTypeFilter, setRequestTypeFilter] = useState(null);
  const [selectProperty, setSelectProperty] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    open: 0,
    scheduled: 0,
    inprogress: 0,
    completed: 0,
    unresolved: 0,
    timetaken: 0,
  });
  const [ticketPropertyList, setTicketPropertyList] = useState([]);
  const [startPage, setStartPage] = useState(1);
  const pageTotal = Math.ceil(stats.total / pageLimit);
  const [ticketIDs, setTicketIDs] = useState([]);
  const [filterTicketObj, setFilterTicketObj] = useState(null);
  const [comapnyTechnicalStaff, setComapnyTechnicalStaff] = useState([]);
  const [comapnyVendors, setComapnyVendors] = useState([]);
  const [url, setUrl] = useState("");
  const [copied, setcopied] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) setcustomActiveTab(tab);
  };

  const tog_large = () => setmodal_large(!modal_large);

  const handlePageChange = (page) => {
    setPageNumber(page);
    if (page > startPage + pageLimit - 1 || page < startPage) {
      setStartPage(Math.max(1, page - Math.floor(pageLimit / 2)));
    }
  };

  const getPropertyManagerList = async () => {
    try {
      const response = await axios.post(`/property_manager/admin`, { company: decode.id });
      if (response?.data?.managers) {
        setPropertyManagerList(response.data.managers);
      }
    } catch (error) {
      console.error("Error fetching property managers:", error);
    }
  };

  useEffect(() => {
    if (decode.role === "company") {
      getPropertyManagerList();
    }
  }, [decode.role]);

  const handleAcceptedFiles = (files) => {
    const formattedFiles = files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(formattedFiles);
  };

  const ClearTicket = (e) => {
    e.preventDefault();
    setSelectPropertyName(null);
    setFilterFromDate("");
    setFilterToDate("");
    setFilterStatus("");
    setFilterTicketObj(null);
    setSelectProperty(null);
    setFiltername("");
    setFilterPropertyManager("");
    setSelectTechnicalStaffName(null);
    setFilterTechnicalStaff("");
    setSelectVendorName(null);
    setFilterVendor("");
    setRequestTypeFilter(null);
    setcol5(false);
  };

  const searchTicket = async (type = "normal") => {
    if (type === "filter") {
      setPageNumber(1);
    }

    try {
      let query = {};
      let response;

      if (decode.role === "customer") {
        query = {
          customerID: decode.id,
          pageNumber,
          startDate: filterFromDate,
          endDate: filterToDate,
          status: filterStatus,
          propertyID: selectProperty?.value || "",
          ticketID: filterTicketObj?.value || "",
          suite: filtername,
          requestType: requestTypeFilter?.value || "",
        };
        response = await axios.post(CUSTOMER_SEARCH_URL, query);
      } else if (decode.role === "manager") {
        query = {
          pageNumber,
          startDate: filterFromDate,
          endDate: filterToDate,
          status: filterStatus,
          propertyID: selectProperty?.value || "",
          ticketID: filterTicketObj?.value || "",
          suite: filtername,
          managerID: decode.id,
          requestType: requestTypeFilter?.value || "",
        };
        response = await axios.post(MANAGER_SEARCH_URL, query);
      } else {
        // Company role
        query = {
          pageNumber,
          startDate: filterFromDate,
          endDate: filterToDate,
          status: filterStatus,
          propertyID: selectProperty?.value || "",
          ticketID: filterTicketObj?.value || "",
          propertyManagerID: filterPropertyManager,
          vendorID: filterVendor,
          technicalStaffID: filterTechnicalStaff,
          suite: filtername,
          companyDomain: decode.domain,
          requestType: requestTypeFilter?.value || "",
        };
        response = await axios.post(COMPANY_SEARCH_URL, query);
      }

      if (response.status === 200) {
        const data = response.data;

        // Critical fix: company returns tickets at root level, others in results.tickets
        const ticketsArray = decode.role === "company" ? data.tickets || [] : data.results?.tickets || [];

        setFilteredTickets(ticketsArray);

        setTicketIDs(
          ticketsArray.map((t) => ({
            value: t._id,
            label: t.primaryID || t._id.substring(0, 8), // fallback if primaryID missing
          }))
        );

        setNotesCount(data.notesCount || {});
        setTotalTickets(data.totalCount || data.total?.Total || 0);
        setTicketPropertyList(data.propertyList || data.results?.propertyList || []);
        setRequestTypes(data.requestTypes || []);

        setStats({
          total: data.total?.Total || data.totalCount || 0,
          open: data.total?.Open?.count || 0,
          scheduled: data.total?.Scheduled?.count || 0,
          completed: data.total?.Completed?.count || 0,
          inprogress: data.total?.Inprogress?.count || 0,
          unresolved: data.total?.Unresolved?.count || 0,
          timetaken: data.total?.TotalTime || 0,
        });
      }
    } catch (error) {
      console.error("Error searching tickets:", error);
    }
  };

  // Initial data load
  useEffect(() => {
    const init = async () => {
      try {
        await Promise.all([
          axios.get("/vendor/get_vendors/" + decode.id).then((res) => {
            if (res.data.success) setComapnyVendors(res.data.vendors);
          }),
          axios.get("/technicalStaff/get_technical_staff/" + decode.id).then((res) => {
            if (res.data.success) setComapnyTechnicalStaff(res.data.technicalStaff);
          }),
          axios
            .get(`company/get-url/?company_id=${decode.id}&role=${decode.role}`)
            .then((res) => {
              if (res.data.status === 200) {
                const fullUrl =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/maintenance-request/" +
                  res.data.data;
                setUrl(fullUrl);
              }
            }),
        ]);
        // Load tickets after dependencies
        searchTicket();
      } catch (err) {
        console.error("Error in initial load:", err);
      }
    };

    init();
  }, []);

  // Pagination change
  useEffect(() => {
    searchTicket();
  }, [pageNumber]);

  const downloadExcel = async () => {
    try {
      const query = {
        role: decode.role,
        id: decode.id,
        startDate: filterFromDate,
        endDate: filterToDate,
        propertyID: selectProperty?.value || "",
      };

      const response = await axios.post(EXCEL_DOWNLOAD_URL, query, {
        responseType: "blob",
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      if (blob.size < 100) throw new Error("Empty or invalid file");

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const now = new Date();
      const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      link.setAttribute("download", `tickets_${dateStr}.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const formatTimeTaken = (totalMinutes) => {
    if (!totalMinutes) return "0 min";
    const years = Math.floor(totalMinutes / (365.25 * 24 * 60));
    const months = Math.floor((totalMinutes % (365.25 * 24 * 60)) / (30.44 * 24 * 60));
    const days = Math.floor((totalMinutes % (30.44 * 24 * 60)) / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = Math.round(totalMinutes % 60);

    const parts = [];
    if (years > 0) parts.push(`${years} yr`);
    if (months > 0) parts.push(`${months} mo`);
    if (days > 0) parts.push(`${days} d`);
    if (hours > 0) parts.push(`${hours} hr`);
    if (minutes > 0 || parts.length === 0) parts.push(`${minutes} min`);

    return parts.join(", ");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Rentdigicare | Maintenance Request</title>
        </MetaTags>

        <div className="col-md-12 mb-3">
          {!["vendor", "technical staff", "manager", "customer"].includes(decode.role) && (
            <CopyToClipboard text={url} onCopy={() => setcopied(true)}>
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(url);
                }}
              >
                Copy Maintenance Link
              </button>
            </CopyToClipboard>
          )}
          {copied && (
            <span className="ms-2 text-success">Copied!</span>
          )}
        </div>

        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Maintenance Request" />

          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col-md-6 d-flex flex-wrap">
                      {["Total", "Open", "Scheduled", "Inprogress", "Completed", "Unresolved"].map((key) => (
                        <div key={key} className="mx-2 mb-2">
                          <h5 className="card-title mb-0">
                            {key}
                            <span className="text-muted fw-normal ms-1">
                              ({stats[key.toLowerCase()] || 0})
                            </span>
                          </h5>
                        </div>
                      ))}
                      <div className="mx-2 mb-2">
                        <h5 className="card-title mb-0" style={{ minWidth: "32rem" }}>
                          Time Taken
                          <span className="text-muted fw-normal ms-1">
                            {formatTimeTaken(stats.timetaken)}
                          </span>
                        </h5>
                      </div>
                    </div>

                    <div className="col-md-6 d-flex flex-wrap align-items-center justify-content-end gap-2">
                      {decode.role !== "customer" && (
                        <button onClick={downloadExcel} className="btn btn-primary">
                          Export Excel
                        </button>
                      )}
                      <button onClick={t_col5} className="btn btn-primary">
                        Filters
                      </button>
                      {(decode.role === "manager" || decode.role === "customer") && (
                        <button
                          onClick={() => history.push("/ticket_manager")}
                          className="btn btn-light"
                        >
                          <i className="bx bx-plus me-1"></i>Add Maintenance Request
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-lg-12">
                      <Collapse isOpen={col5}>
                        <Card>
                          <CardBody>
                            <Form>
                              <div className="row align-items-end">
                                <div className="col-md-3">
                                  <Label>From</Label>
                                  <Input
                                    type="date"
                                    value={filterFromDate}
                                    onChange={(e) => setFilterFromDate(e.target.value)}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <Label>To</Label>
                                  <Input
                                    type="date"
                                    value={filterToDate}
                                    onChange={(e) => setFilterToDate(e.target.value)}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <Label>Request ID</Label>
                                  <Select
                                    value={filterTicketObj}
                                    onChange={setFilterTicketObj}
                                    options={ticketIDs}
                                    isClearable
                                    placeholder="Select ticket ID"
                                  />
                                </div>
                                <div className="col-md-3">
                                  <Label>Status</Label>
                                  <Select
                                    value={filterStatus ? { value: filterStatus, label: filterStatus } : null}
                                    onChange={(opt) => setFilterStatus(opt ? opt.value : "")}
                                    options={[
                                      { value: "Open", label: "Open" },
                                      { value: "Scheduled", label: "Scheduled" },
                                      { value: "Inprogress", label: "Inprogress" },
                                      { value: "Completed", label: "Completed" },
                                      { value: "Unresolved", label: "Unresolved" },
                                    ]}
                                    isClearable
                                  />
                                </div>
                                <div className="col-md-3">
                                  <Label>Property</Label>
                                  <Select
                                    value={selectProperty}
                                    onChange={setSelectProperty}
                                    options={ticketPropertyList.map((p) => ({
                                      value: p._id,
                                      label: p.title,
                                    }))}
                                    isClearable
                                    placeholder="Select property"
                                  />
                                </div>

                                {userRole === "company" && (
                                  <>
                                    <div className="col-md-3">
                                      <Label>Property Manager</Label>
                                      <Select
                                        value={selectPropertyName}
                                        onChange={(opt) => {
                                          setSelectPropertyName(opt);
                                          setFilterPropertyManager(opt?.value || "");
                                        }}
                                        options={propertyManagerList.map((m) => ({
                                          value: m._id,
                                          label: `${m.firstname} ${m.lastname}`,
                                        }))}
                                        isClearable
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <Label>Vendors</Label>
                                      <Select
                                        value={selectVendorName}
                                        onChange={(opt) => {
                                          setSelectVendorName(opt);
                                          setFilterVendor(opt?.value || "");
                                        }}
                                        options={comapnyVendors.map((v) => ({
                                          value: v._id,
                                          label: `${v.first_name} ${v.last_name}`,
                                        }))}
                                        isClearable
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <Label>Technical Staff</Label>
                                      <Select
                                        value={selectTechnicalStaffName}
                                        onChange={(opt) => {
                                          setSelectTechnicalStaffName(opt);
                                          setFilterTechnicalStaff(opt?.value || "");
                                        }}
                                        options={comapnyTechnicalStaff.map((t) => ({
                                          value: t._id,
                                          label: `${t.first_name} ${t.last_name}`,
                                        }))}
                                        isClearable
                                      />
                                    </div>
                                  </>
                                )}

                                <div className="col-md-3">
                                  <Label>Request Type</Label>
                                  <Select
                                    value={requestTypeFilter}
                                    onChange={setRequestTypeFilter}
                                    options={requestTypes.map((type) => ({
                                      value: type,
                                      label: type,
                                    }))}
                                    isClearable
                                  />
                                </div>
                                <div className="col-md-3">
                                  <Label>Suite</Label>
                                  <Input
                                    type="text"
                                    value={filtername}
                                    onChange={(e) => setFiltername(e.target.value)}
                                    placeholder="Enter suite"
                                  />
                                </div>

                                <div className="col-md-12 text-end mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => searchTicket("filter")}
                                  >
                                    Search
                                  </button>
                                  <button type="button" className="btn btn-secondary" onClick={ClearTicket}>
                                    Clear
                                  </button>
                                </div>
                              </div>
                            </Form>
                          </CardBody>
                        </Card>
                      </Collapse>
                    </div>
                  </div>
                </CardHeader>

                <CardBody>
                  <div className="table-responsive">
                    <Table className="table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>ID</th>
                          <th style={{ minWidth: "110px" }}>Suite No.</th>
                          <th>Type</th>
                          {decode.role !== "customer" && (
                            <>
                              <th>Property</th>
                              <th style={{ minWidth: "110px" }}>Submitted By</th>
                            </>
                          )}
                          <th style={{ minWidth: "80px" }}>Created</th>
                          <th style={{ minWidth: "80px" }}>Age</th>
                          <th style={{ minWidth: "50px" }}>Permission</th>
                          <th>Workflow Details</th>
                          <th style={{ minWidth: "50px" }}>Status</th>
                          <th>Download</th>
                          <th>Action</th>
                          {(decode.role === "company" || decode.role === "manager") && <th>Assign To</th>}
                          {decode.role !== "customer" && <th>History</th>}
                          <th>Memo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <TicketListRow
                          filteredTickets={filteredTickets}
                          notesCount={notesCount}
                          searchTicket={searchTicket}
                          totalTickets={totalTickets}
                          setTotalTickets={setTotalTickets}
                        />
                      </tbody>
                    </Table>
                  </div>

                  <Row className="mt-4">
                    <Col xl={12}>
                      <div className="pagination-bar d-flex justify-content-center">
                        <Pagination>
                          <PaginationItem disabled={pageNumber === 1}>
                            <PaginationLink first onClick={() => handlePageChange(1)} />
                          </PaginationItem>
                          <PaginationItem disabled={pageNumber === 1}>
                            <PaginationLink previous onClick={() => handlePageChange(pageNumber - 1)} />
                          </PaginationItem>
                          {Array.from({ length: pageLimit }, (_, i) => startPage + i)
                            .filter((p) => p <= pageTotal)
                            .map((page) => (
                              <PaginationItem key={page} active={pageNumber === page}>
                                <PaginationLink onClick={() => handlePageChange(page)}>
                                  {page}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                          <PaginationItem disabled={pageNumber === pageTotal}>
                            <PaginationLink next onClick={() => handlePageChange(pageNumber + 1)} />
                          </PaginationItem>
                          <PaginationItem disabled={pageNumber === pageTotal}>
                            <PaginationLink last onClick={() => handlePageChange(pageTotal)} />
                          </PaginationItem>
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketList;